/* eslint import/prefer-default-export: "off" */
import { ColumnType, ColumnProps } from '@src/components/data.grid'
import generateDetailsLink from '@src/utils/generate.details.link'
import type { UsageInfo } from '@src/endpoints/services/commonHdr.service'

export const userActivityColumns = ({ history }): ColumnProps<UsageInfo>[] => [
  {
    field: 'event_name',
    title: 'Event Name'
  },
  {
    field: 'identity_name',
    title: 'Identity',
    clickable: item =>
      item.identity_uri && item.identity_type && item.identity_account_id,
    onClick: item => {
      const url = generateDetailsLink(item.identity_uri)
      history.push(url)
    }
  },
  {
    field: 'identity_account_id',
    title: 'Identity Source'
  },

  {
    field: 'resource_name',
    title: 'Resource',
    clickable: item =>
      item.resource_uri && item.resource_type && item.resource_account_id,
    onClick: item => {
      const url = generateDetailsLink(item.resource_uri)
      history.push(url)
    }
  },
  {
    field: 'resource_account_id',
    title: 'Resource Source'
  },
  {
    field: 'ip_address',
    title: 'IP Address'
  },
  {
    field: 'user_agent',
    title: 'User Agent'
  },

  {
    field: 'timestamp',
    title: 'Timestamp',
    type: ColumnType.datetime
  }
]
